module.exports = __webpack_public_path__ + "dollar_bag.e4ffe846cc25d672c8b6c3be63e8f691.svg";